import React, { Component } from "react";
import MediaHeavy from "./pageTypes/mediaHeavy";
import BasicPage from "./pageTypes/basicPage";
import Loader from "./loader";
import ErrorComponent from "./errorComponent";
import "./assets/App.css";
import GDPR from "./GDPR";
import Alert from "./alert/";
import TagManager from "react-gtm-module";

let BASE_URI = "";
let full_path = "";
let path = "";
let UIPath = "";
let BACKUP_URI = "";
let FILE_CACHE = "";
let ALERT = "";
let ALERT_MESSAGE = "";
let ALERT_SYSTEM_URL = "";
const tagManagerArgs = {
  gtmId: "GTM-MXGB7Z",
};
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: [],
      config: [],
      nodeid: [],
      alert: [],
      emergency: [],
      pageType: "",
      loading: true,
      node: "",
      error: false,
      height: 0,
      width: 0,
    };
    this.updateDimensions = this.updateDimensions.bind(this);
    this.saveData = this.saveData.bind(this);
  }

  componentWillMount() {
    path = window.location.pathname.replace(/^\/+|\/+$/g, ""); // strip preceding and trailing '/'
    switch (window.location.hostname) {
      case "react.drup2-dev.uvm.edu":
      case "localhost":
        BASE_URI = "https://content.drup2-dev.uvm.edu/json/";
        BACKUP_URI = "https://react.drup2-dev.uvm.edu/data/undergradAdmit/";
        FILE_CACHE = "https://content.drup2-dev.uvm.edu/shared/fileCache.php";
        ALERT = "https://content.drup2-dev.uvm.edu/shared/directAlert.php";
        UIPath = "https://djlefebv1.drup-lb.uvm.edu/";
        ALERT_MESSAGE = {
          message:
            "Drup2 Dev server is down or in maintenance mode. Pages served from static cached data",
        };
        ALERT_SYSTEM_URL = "https://www.uvm.edu/json/emergency";
        break;
      case "react.drup2-staging.uvm.edu":
        BASE_URI = "https://content.drup2-staging.uvm.edu/json/";
        BACKUP_URI = "https://react.drup2-staging.uvm.edu/data/undergradAdmit/";
        FILE_CACHE =
          "https://content.drup2-staging.uvm.edu/shared/fileCache.php";
        ALERT = "https://content.drup2-staging.uvm.edu/shared/directAlert.php";
        UIPath = "https://staging.drup-lb.uvm.edu/";
        ALERT_MESSAGE = {
          message:
            "Drup2 Staging server is down or in maintenance mode. Serving pages from static cached data",
        };
        ALERT_SYSTEM_URL = "https://staging.drup-lb.uvm.edu/json/emergency";
        break;
      default:
        if (window.location.hostname !== "react.uvm.edu") {
          TagManager.initialize(tagManagerArgs);
        }
        BASE_URI = "https://content.uvm.edu/json/";
        BACKUP_URI = "https://www.uvm.edu/content/shared/data/undergradAdmit/";
        FILE_CACHE = "https://content.uvm.edu/shared/fileCache.php";
        ALERT = "https://content.uvm.edu/shared/directAlert.php";
        UIPath = "https://www.uvm.edu/";
        ALERT_MESSAGE = {
          message:
            "Content production data server is down or in maintenance mode. Serving pages from static cached data",
        };
        ALERT_SYSTEM_URL = "https://www.uvm.edu/json/emergency";
    }
    if (path === "") {
      // Root path = 'node'
      full_path = BASE_URI + "node?alias=node";
    } else if (path.substring(0, 5) === "node/") {
      // Requests by 'node/...'
      full_path = BASE_URI + path;
    } else {
      // Alias and redirect path requests
      full_path = BASE_URI + "node?alias=" + path;
    }
  }

  handleErrors(response) {
    if (!response.ok) {
      // Throw all errors
      throw Error(response.status);
    }
    return response;
  }

  saveData() {
    let appdata = this.state.page;
    appdata["appname"] = "undergradAdmit";
    appdata["pagePath"] = path !== "" ? path : "node";

    fetch(FILE_CACHE, {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ appdata }),
    }).then(function (response) {
      console.log(" ->", response);
    });
  }

  sendAlert() {
    fetch(ALERT, {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ALERT_MESSAGE }),
    }).then(function (response) {
      console.log(" ->", response);
    });
  }

  updateDimensions() {
    if (window.innerWidth !== this.state.width && window.innerWidth > 600) {
      this.setState(
        {
          height: window.innerHeight,
          width: window.innerWidth,
        },
        () => {
          window.location.reload();
        }
      );
    }
  }

  updateHead() {
    if (typeof this.state.page.og_group_ref === "undefined") {
      document.title = this.state.page.title + " | The University of Vermont";
    } else {
      document.title =
        this.state.page.title +
        " | " +
        this.state.page.og_group_ref.name +
        " | The University of Vermont";
    }
    if (
      typeof this.state.page.metatags !== "undefined" &&
      typeof this.state.page.metatags.description !== "undefined"
    ) {
      document.getElementsByTagName(
        "meta"
      )[0].content = this.state.page.metatags.description.value;
    } else if (typeof this.state.page.body !== "undefined") {
      document.getElementsByTagName(
        "meta"
      )[0].content = this.state.page.body.substring(0, 400);
    }
    document.getElementsByTagName("link")[0].href =
      "https://www.uvm.edu/" + this.state.page.path.alias;
  }

  componentDidMount() {
    if (ALERT_MESSAGE !== "") {
      this.setState({
        height: window.innerHeight,
        width: window.innerWidth,
      });
      window.addEventListener("resize", this.updateDimensions);
      fetch(ALERT_SYSTEM_URL)
        .then((response) => response.json())
        .then((data) =>
          this.setState({
            alert: data.data.alert,
            emergency: data.data.emergency,
          })
        )
        .catch(console.log("<--Emergency Json Not Found -->"));

      fetch(full_path)
        .then(this.handleErrors) // handles response errors like 404 (NOT 301 because require json data)
        .then((response) => response.json())
        .then((data) =>
          this.setState(
            {
              loading: false,
              node: data.data,
              pageType: data.data.type,
              page: data.data,
            },
            () => {
              this.updateHead();
              this.saveData();
            }
          )
        )
        .catch(
          //error => this.setState({ loading: false, error }),
          (e = Error) => {
            //console.log("Catch Error ->", this.state.error);
            //const message = this.state.error;
            //console.log(" ->", e.message);
            switch (e.message) {
              case "404":
                //case "301":
                this.setState({
                  error: e,
                  //                  pageType: "redirect",
                  loading: false,
                });
                break;
              default:
                let filepath = path.replace(/\//g, "_");
                const fullPath = BACKUP_URI + filepath + ".json";
                fetch(fullPath)
                  //.then(this.handleErrors) // handles response errors like 404
                  .then((response) => response.json())
                  .then((data) =>
                    this.setState(
                      {
                        loading: false,
                        node: data.appdata,
                        pageType: data.appdata.type,
                        page: data.appdata,
                      },
                      () => {
                        console.log("<-- Data Loaded From File -->");
                        this.updateHead();
                        this.sendAlert();
                      }
                    )
                  );
            }
          }
        );
    }
  }

  render() {
    console.log(" Alert->", this.state.alert);
    console.log(" Emergecy Alert->", this.state.emergency);
    const emergencyLink =
      "https://www.uvm.edu/" + this.state.emergency.link_path;
    const alertLink = "https://www.uvm.edu/" + this.state.alert.link_path;

    const { pageType, page, error } = this.state;
    if (error) {
      console.log("state->", this.state);
      return <ErrorComponent error={error} data={this.state.redirect} />;
    } else {
      switch (pageType) {
        case "media_heavy_page":
          return (
            <>
              <MediaHeavy page={page} />
              <GDPR />
            </>
          );
        case "page":
          return (
            <>
              <BasicPage page={page} />
              <GDPR />
            </>
          );
        case "redirect":
          return <ErrorComponent error={{ message: "301" }} data={page} />;
        default:
          return <Loader />;
      }
    }
  }
}

export default App;
